import { Modal } from 'common/modal';
import { useEffect } from 'react';
import { msToRecallMeEndpoint } from 'config/constants';
import { SubscriptionStatus } from 'common/enums';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { PaymentInProgress } from 'common/payment-in-progress';
import styles from './modal-processing-vault-payment.module.scss';

type ModalProcessingVaultPaymentProps = {
  title: string;
  vaultResponse: VaultType;
  disableManualClosing?: boolean;
  closeFn: (vault: VaultType) => void;
  errorFn: () => void;
};

const ModalProcessingVaultPayment: React.FC<
  ModalProcessingVaultPaymentProps
> = ({ title, vaultResponse, disableManualClosing, closeFn, errorFn }) => {
  const verifyVaultSubscriptionStatus = async () => {
    try {
      const vault = await VaultsController.getVault(vaultResponse.id);
      const { subscriptionStatus } = vault;

      if (
        subscriptionStatus === SubscriptionStatus.subscriptionActive ||
        subscriptionStatus === SubscriptionStatus.paymentFailed
      ) {
        closeFn(vault);
      }
    } catch (err: any) {
      errorFn();
    }
  };

  useEffect(() => {
    const timer: NodeJS.Timeout = setInterval(() => {
      verifyVaultSubscriptionStatus();
    }, msToRecallMeEndpoint);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Modal
      className={styles.processingContent}
      title={title}
      disableManualClosing={disableManualClosing}
    >
      <PaymentInProgress />
    </Modal>
  );
};

export { ModalProcessingVaultPayment };
